
<template>
  <div class="can-go-dark" style="height: 100%">

    <div :style="$mq=='desktop'?'height: 100%':''">
      <toolbar></toolbar>
      
      <section class="section" style="height:100%; padding-top:1rem; padding-bottom:0">
        <div class="columns" style="height:100%; justify-content: flex-end;">
          <div class="column is-6" style="position: relative;">
            <spinningwheel ref="spinningwheel"
              v-on:wheel-started="wheelStarted"
              v-on:name-changed="nameChanged"
              v-on:wheel-stopped="wheelStopped"
            ></spinningwheel>
          </div>
          
          <div class="column is-3" style="height:90%;">
            <name-tabs style="height:100%"
              v-on:reset-wheel-rotation="resetWheelRotation"
            />
          </div>
        </div>
      </section>
    </div>

    <winnerdialog
      ref="winnerdialog"
      v-on:remove-entry="removeEntry"
    ></winnerdialog>

    <RiggingPanel />
  </div>
</template>

<script>
  import toolbar from '../toolbar.vue';
  import spinningwheel from '../spinningwheel.vue';
  import nameTabs from '../nameTabs.vue';
  import winnerdialog from '../winnerdialog.vue';
  import RiggingPanel from '../components/RiggingPanel.vue';
  import * as ConfettiLauncher from '../ConfettiLauncher.js';
  import * as Audio from '../audio.js';
  import * as Util from '../Util.js';
  import { mapGetters } from "vuex";

  export default {
    components: {
      toolbar, spinningwheel, nameTabs, winnerdialog, RiggingPanel
    },
    mounted() {
      this.$store.dispatch('loadInitialWheel');
      this.$store.dispatch('loadPreferences');
      document.fonts.ready.then(() => {
        this.$refs.spinningwheel.refresh();
      });
        Util.updateColorStyles(this.darkMode, '#777', this.wheelConfig.pageBackgroundColor);
    },
    computed: {
      ...mapGetters([
        'wheelConfig', 'wheelIsBusy', 'darkMode'
      ])
    },
    watch: {
      darkMode() {
        Util.updateColorStyles(this.darkMode, '#777', this.wheelConfig.pageBackgroundColor);
      }
    },
    methods: {
      resetWheel() {
        this.$store.dispatch('resetWheel');
        this.$refs.spinningwheel.resetRotation();
      },
      nameChanged() {
        if (this.wheelIsBusy && this.wheelConfig.shouldPlayTicks()) {
          Audio.playTick(this.wheelConfig.duringSpinSoundVolume);
        }
      },
      wheelStarted() {
        Audio.startMusic(this.wheelConfig.duringSpinSound, this.wheelConfig.duringSpinSoundVolume);
      },
      wheelStopped(winningEntry) {
        Audio.fadeMusic();
        this.$store.commit('addWinner', winningEntry);
        
        if (this.wheelConfig.launchConfetti) {
          ConfettiLauncher.launch(this.wheelConfig.getCoalescedColors());
        }
        
        if (this.wheelConfig.displayWinnerDialog) {
          this.$refs.winnerdialog.show(winningEntry);
        }
        
        if (this.wheelConfig.autoRemoveWinner) {
          const duration = 5;
          this.$store.commit('setWheelBusy', true);
          setTimeout(() => this.removeEntry(winningEntry), 1000 * duration);
          setTimeout(() => this.$store.commit('setWheelBusy', false), 1000 * duration);
        }
        
        Audio.playAfterSpin(
          winningEntry.sound || this.wheelConfig.afterSpinSound,
          winningEntry.text,
          this.wheelConfig.afterSpinSoundVolume,
          'en'
        );
      },
      removeEntry(entry) {
        if (this.wheelConfig.playClickWhenWinnerRemoved) {
          Audio.playClick(this.wheelConfig.afterSpinSoundVolume);
        }
        this.$store.commit('removeEntry', entry);
      },
      resetWheelRotation() {
        this.$refs.spinningwheel.resetRotation();
      },
    }
  }
</script>

<style>
  .can-go-dark {}
</style>
